import { eventQBus } from "@otto-ec/event-q-bus";

// Export Debug functionality to global namespace.
window.o_global = window.o_global || {};
window.o_global.eventQBus = window.o_global.eventQBus || eventQBus();
window.o_global.events = () => window.o_global.eventQBus as never;
